import React from 'react';
import { getPaymentState, PAYMENT_META, inrCompact } from './poPayment';

const CHIPS = [
  { id: 'all', label: 'All POs', active: 'bg-fuchsia-600 text-white border-fuchsia-600 shadow-sm', idle: 'text-slate-700 hover:bg-white' },
  { id: 'paid', label: 'Paid', active: 'bg-emerald-600 text-white border-emerald-600 shadow-sm', idle: 'text-emerald-800 hover:bg-emerald-50' },
  { id: 'pending', label: 'Pending', active: 'bg-amber-500 text-white border-amber-500 shadow-sm', idle: 'text-amber-800 hover:bg-amber-50' },
  { id: 'overdue', label: 'Overdue', active: 'bg-red-600 text-white border-red-600 shadow-sm', idle: 'text-red-800 hover:bg-red-50' },
  { id: 'cancelled', label: 'Cancelled', active: 'bg-slate-600 text-white border-slate-600 shadow-sm', idle: 'text-slate-600 hover:bg-white' },
];

export default function POQuickFilterChips({ pos, value, onChange }) {
  const stats = React.useMemo(() => {
    const s = { all: { n: 0, amt: 0 }, paid: { n: 0, amt: 0 }, pending: { n: 0, amt: 0 }, overdue: { n: 0, amt: 0 }, cancelled: { n: 0, amt: 0 } };
    (pos || []).forEach((po) => {
      const st = getPaymentState(po);
      const amt = Number(po.total) || 0;
      s.all.n += 1; s.all.amt += amt;
      if (s[st]) { s[st].n += 1; s[st].amt += amt; }
    });
    return s;
  }, [pos]);

  return (
    <div className="flex flex-wrap items-center gap-1.5 mb-4 p-1.5 bg-slate-100/70 rounded-xl w-fit border border-slate-200/60" data-testid="po-quick-filter-chips">
      {CHIPS.filter((c) => c.id !== 'cancelled' || stats.cancelled.n > 0 || value === 'cancelled').map((c) => {
        const on = (value || 'all') === c.id;
        const st = stats[c.id];
        return (
          <button
            key={c.id}
            type="button"
            onClick={() => onChange(c.id)}
            className={`px-3 py-1.5 rounded-lg text-xs font-semibold border transition-[background-color,color,transform] duration-150 active:scale-95 flex items-center gap-2 ${on ? c.active : `border-transparent ${c.idle}`}`}
            data-testid={`po-filter-chip-${c.id}`}
            aria-pressed={on}
          >
            {c.id !== 'all' && <span className={`w-1.5 h-1.5 rounded-full ${on ? 'bg-white' : PAYMENT_META[c.id].dot}`} />}
            <span>{c.label}</span>
            <span className={`tabular-nums px-1.5 rounded-md ${on ? 'bg-white/20' : 'bg-white/80 text-slate-600'}`} data-testid={`po-filter-chip-count-${c.id}`}>{st.n}</span>
            <span className={`tabular-nums font-medium ${on ? 'text-white/85' : 'text-slate-500'}`}>{inrCompact(st.amt)}</span>
          </button>
        );
      })}
    </div>
  );
}
